// The Auto-scroll rule's position check: the tail follows while the view
// sits within the threshold of the bottom (and the sidebar switch is on;
// the gating lives in the useAutoScroll hook).

/** How close to the bottom (px) still counts as "at the end". */
export const FOLLOW_THRESHOLD_PX = 50;

// The list scrolls on OverlayScrollbars, whose real scrolling element is
// an inner viewport — resolve it from the ref'd shell (falling back to
// the shell itself, e.g. before the library initializes).
export function scrollViewportOf(
  shell: HTMLDivElement | null,
): HTMLElement | null {
  return (
    shell?.querySelector<HTMLElement>("[data-overlayscrollbars-viewport]") ??
    shell
  );
}

export function isNearBottom(
  scrollTop: number,
  scrollHeight: number,
  clientHeight: number,
): boolean {
  return scrollHeight - scrollTop - clientHeight < FOLLOW_THRESHOLD_PX;
}

/** What a scroll event does to the transient tail-follow: scrolling
 *  away always lets go; scrolling to the bottom takes hold only while
 *  the tail is live. Paused, nothing is arriving to follow — and a
 *  history page's restored position near the bottom must not turn the
 *  pin back on over the anchor. `null` leaves the state as it is. */
export function nextFollowState(
  nearBottom: boolean,
  streaming: boolean,
): boolean | null {
  if (!nearBottom) return false;
  return streaming ? true : null;
}
